const Styles = {
    'FilterFieldset': 'FilterFieldset_FilterFieldset--867cd029'
};

export default Styles;